import { render } from "./ProfessorSessionOverview.vue?vue&type=template&id=25a33185"
import script from "./ProfessorSessionOverview.vue?vue&type=script&lang=js"
export * from "./ProfessorSessionOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__